import React, { useState } from 'react'
//Owl Carousel Libraries and Module
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ItemCard from './ItemCard';

const Carousal = ({ item }) => {

   

    return (
        <>
            <OwlCarousel
            loop = {false}
            margin={10}
            nav
            navText={['<', '>']}
            autoWidth
            
            >
                {
                    item.map((item) => {
                        const { id, title, description, image } = item
                        return (
                            <div className="item" key={id}>
                                <ItemCard 
                                itemImg = {image}
                                itemName={title}
                                itemShortDescription={description}
                               />
                            </div>
                        )
                    })
                }
            </OwlCarousel>
        </>
    )
}

export default Carousal